<template>
<div class='category-card'>
  <div class='cover-wrapper' v-if="category.cover_url">
    <div class='img' :style="{ backgroundImage: 'url( '+category.cover_url+')' }" />
    <!-- <div class='img default' v-else /> -->
  </div>
  <div class='details' :class="{'empty': !category.cover_url}">
    <h1>{{category.name}}</h1>
    <p class='description'>{{category.description}}</p>
    <div class='public-link' v-if='category.publicity'>
      <i class='ppj-icon-link'></i>{{$t('actions.category.publicity')}}：<a class='link' :href="category.public_url" target='_blank'>{{category.public_url}}</a>
    </div>
    <div class='actions'>
      <el-button @click="$emit('edit')">{{$t('actions.category.edit')}}</el-button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['category']
}
</script>

<style lang='scss' scoped>
$cover-image-height: 140px;
$height: $cover-image-height + 2 * $padding-base;

.category-card {
    position: relative;
    overflow: hidden;
    background-color: $color-white-base;
    width: 100%;
    height: $height;
    box-shadow: $box-shadow-base;

    .cover-wrapper {
        float: left;
        width: $cover-image-height;
        height: $cover-image-height;
        text-align: center;
        margin: $padding-base;
        .img {
            &.default {
                background-image: url('~@/assets/images/category-cover-default.png');
            }
        }
    }

    .details {
        position: absolute;
        padding: $padding-base $padding-base $padding-base $cover-image-height + 2 * $padding-base + $margin-base;
        width: 100%;
        height: $height;

        .public-link {
            position: absolute;
            bottom: 0;
            margin-bottom: $padding-base;
        }

        .actions {
            position: absolute;
            right: $padding-base;
            top: $padding-base;
        }

        &.empty {
            padding-left: 2 * $padding-base;
        }
    }
}
</style>



// WEBPACK FOOTER //
// info.vue?6db13776